import {
  BOOKING_LIST_UPCOMING_SUCCESS,
  BOOKING_LIST_UPCOMING_ERROR,
  BOOKING_LIST_UPCOMING_START,
  BOOKING_LIST_ONGOING_START,
  BOOKING_LIST_ONGOING_ERROR,
  BOOKING_LIST_ONGOING_SUCCESS,
  BOOKING_LIST_CANCEL_START,
  BOOKING_LIST_CANCEL_ERROR,
  BOOKING_LIST_CANCEL_SUCCESS,
  BOOKING_LIST_COMPLETE_START,
  BOOKING_LIST_COMPLETE_ERROR,
  BOOKING_LIST_COMPLETE_SUCCESS,
  BOOKING_LIST_UT_SUCCESS,
  BOOKING_LIST_OT_SUCCESS,
  BOOKING_LIST_CT_SUCCESS,
  BOOKING_LIST_CNT_SUCCESS,
  BOOKING_LIST_ERROR,
  BOOKING_LIST_START,
  COMPLETED_BOOKINGS_LIST_START,
  COMPLETED_BOOKINGS_LIST_SUCCESS,
  COMPLETED_BOOKINGS_LIST_ERROR,
} from "../Actions/BookingAction";

const initialState = {
  loading: false,
  bookingUpcomingList: [],
  bookingOngingList: [],
  bookingCompleteList: [],
  bookingCancelList: [],
  bookingUTList: [],
  bookingOTList: [],
  bookingCTList: [],
  bookingCNTList: [],
};

export default function BookingReducer(state = { ...initialState }, action) {
  switch (action.type) {
    case BOOKING_LIST_UPCOMING_START:
      return {
        ...state,
        loading: true,
      };
    case BOOKING_LIST_UPCOMING_SUCCESS:
      return {
        ...state,
        bookingUpcomingList: action.payload,
        loading: false,
      };
    case BOOKING_LIST_UPCOMING_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case BOOKING_LIST_ONGOING_START:
      return {
        ...state,
        loading: true,
      };
    case BOOKING_LIST_ONGOING_SUCCESS:
      return {
        ...state,
        bookingOngingList: action.payload,
        loading: false,
      };
    case BOOKING_LIST_ONGOING_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case BOOKING_LIST_CANCEL_START:
      return {
        ...state,
        loading: true,
      };
    case BOOKING_LIST_CANCEL_SUCCESS:
      return {
        ...state,
        bookingCancelList: action.payload,
        loading: false,
      };
    case BOOKING_LIST_CANCEL_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case BOOKING_LIST_COMPLETE_START:
      return {
        ...state,
        loading: true,
      };
    case BOOKING_LIST_COMPLETE_SUCCESS:
      return {
        ...state,
        bookingCompleteList: action.payload,
        loading: false,
      };
    case BOOKING_LIST_COMPLETE_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case BOOKING_LIST_START:
      return {
        ...state,
        loading: true,
      };
    case BOOKING_LIST_UT_SUCCESS:
      return {
        ...state,
        bookingUTList: action.payload,
        loading: false,
      };
    case BOOKING_LIST_OT_SUCCESS:
      return {
        ...state,
        bookingOTList: action.payload,
        loading: false,
      };
    case BOOKING_LIST_CT_SUCCESS:
      return {
        ...state,
        bookingCTList: action.payload,
        loading: false,
      };
    case BOOKING_LIST_CNT_SUCCESS:
      return {
        ...state,
        bookingCNTList: action.payload,
        loading: false,
      };
    case BOOKING_LIST_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case COMPLETED_BOOKINGS_LIST_START:
      return {
        ...state,
        loading: true,
      };
    case COMPLETED_BOOKINGS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case COMPLETED_BOOKINGS_LIST_ERROR:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}
